import { useAuth0 } from '@auth0/auth0-react'
import { useHasScope } from '~hooks/permissions/use-has-scope'
import ChatbotWidget from './chatbot-widget'

export default function AuthenticatedChatbot() {
  const { isAuthenticated, isLoading } = useAuth0()
  const hasChatbotScope = useHasScope('feature:chatbot')

  if (isLoading || !isAuthenticated || !hasChatbotScope) {
    return null
  }

  return <ChatbotWidget />
}
